<div class="download-forms-section">
  <div class="download-forms-heading">
    Download Forms
  </div>
  <div class="download-forms-body">
    <div class="form-card">
      <div class="form-details">
        <div class="pdf-icon">
          <img src="../../../../assets/images/pdfLogo.png" alt="">
        </div>
        <div class="form-content">
          <div class="form-name">Health Claim Form</div>
          <div class="form-description">Download the form to submit your health claim.</div>
        </div>

      </div>
      <div class="action-icons">
        <div class="download-icon">
          <a href="assets/pdf/Health Claim Form.pdf" (click)="trackForm('Health Claim Form')" target="_blank" class="download-form">
            <img src="../../../../assets/images/download-icon-black.png" alt="">
          </a>
        </div>
        <!-- <div class="share-icon">
          <img src="../../../../assets/images/share-icon-black.png" alt="">
        </div> -->
      </div>
    </div>

    <div class="form-card">
      <div class="form-details">
        <div class="pdf-icon">
          <img src="../../../../assets/images/pdfLogo.png" alt="">
        </div>
        <div class="form-content">
          <div class="form-name">Pre Authorization</div>
          <div class="form-description">Required for planned hospitalization approval.</div>
        </div>

      </div>
      <div class="action-icons">
        <div class="download-icon">
          <a href="assets/pdf/Health Pre-Authorization Claim Form.pdf" (click)="trackForm('Health Pre-Authorization Claim Form')" target="_blank" class="download-form">
            <img src="../../../../assets/images/download-icon-black.png" alt="">
          </a>
        </div>
        <!-- <div class="share-icon">
          <img src="../../../../assets/images/share-icon-black.png" alt="">
        </div> -->
      </div>
    </div>

    <div class="form-card">
      <div class="form-details">
        <div class="pdf-icon">
          <img src="../../../../assets/images/pdfLogo.png" alt="">
        </div>
        <div class="form-content">
          <div class="form-name">OPD Claim Form</div>
          <div class="form-description">Download the form for outpatient claim submission.</div>
        </div>

      </div>
      <div class="action-icons">
        <div class="download-icon">
          <a href="assets/pdf/OPD_Claim Form.pdf" (click)="trackForm('OPD Claim Form')" target="_blank" class="download-form">
            <img src="../../../../assets/images/download-icon-black.png" alt="">
          </a>
        </div>
        <!-- <div class="share-icon">
          <img src="../../../../assets/images/share-icon-black.png" alt="">
        </div> -->
      </div>
    </div>
  </div>
</div>